import { useCallback } from 'react';
import { postApi } from '../../services/apiBase';
import { assistant_session } from '../../services/apiURL';

/**
 * Friendly states the widget renders for each session-mint failure. Codes come
 * from the Tools endpoint (POST /api/tools/assistant/session).
 */
export const SESSION_ERRORS = {
    NOT_CONFIGURED: 'NOT_CONFIGURED',
    NO_EMAIL: 'NO_EMAIL',
    USER_NOT_FOUND: 'USER_NOT_FOUND',
    UPSTREAM: 'UPSTREAM',
};

export class AristotleSessionError extends Error {
    constructor(code) {
        super(`Aristotle session mint failed: ${code}`);
        this.code = code;
    }
}

/**
 * Mint a one-time Aristotle embed session via the SIS backend (which holds the
 * per-tenant shared secret). Resolves { code, expiresAt, webUrl, product };
 * rejects with AristotleSessionError carrying a SESSION_ERRORS code.
 */
export const useAristotleSession = () => {
    const mint = useCallback(async () => {
        let response;
        try {
            // _suppressErrorPopup: failures render inside the widget, never as
            // the global SweetAlert error modal.
            response = await postApi(assistant_session, null, { _suppressErrorPopup: true });
        } catch (error) {
            const code = error?.response?.data?.data;
            throw new AristotleSessionError(
                typeof code === 'string' && SESSION_ERRORS[code] ? code : SESSION_ERRORS.UPSTREAM,
            );
        }
        const session = response?.data?.data;
        if (!session?.code || !session?.webUrl) {
            throw new AristotleSessionError(SESSION_ERRORS.UPSTREAM);
        }
        return session;
    }, []);

    return { mint };
};
